import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = { class: "table-responsive" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "table-title" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createTextVNode("Manage "),
            /*#__PURE__*/ _createElementVNode("b", null, "Users")
        ])
    ])
], -1);
const _hoisted_5 = { class: "table table-striped table-hover" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Name"),
        /*#__PURE__*/ _createElementVNode("th", null, "Email"),
        /*#__PURE__*/ _createElementVNode("th", null, "Mode"),
        /*#__PURE__*/ _createElementVNode("th", null, "Actions")
    ])
], -1);
const _hoisted_7 = { key: 0 };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ModalsContainer = _resolveComponent("ModalsContainer");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("table", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: user.id
                                }, [
                                    _createElementVNode("td", null, _toDisplayString(user.name), 1),
                                    _createElementVNode("td", null, _toDisplayString(user.email), 1),
                                    _createElementVNode("td", null, _toDisplayString(user.mode), 1),
                                    (user.email != _ctx.userSession.email)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (_ctx.editItem(user)),
                                                class: "fa fa-edit",
                                                "data-toggle": "modal"
                                            }, null, 8, _hoisted_8),
                                            _createElementVNode("button", {
                                                onClick: ($event) => (_ctx.removeItem(user)),
                                                class: "fa fa-remove",
                                                "data-toggle": "modal"
                                            }, null, 8, _hoisted_9)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ])
                    ])
                ])
            ])
        ]),
        _createVNode(_component_ModalsContainer, { item: _ctx.userSelected }, null, 8, ["item"])
    ], 64));
}
